<div class="nav-siniestro">
  @for (btn of botones; track btn) {
    <app-botones-icon-seccion class="icon-card"
      [titulo]="procesarTitulo(btn)"
      [icono]="btn.icono"
      [iconoHover]="btn.iconoHover"
      [iconoSeleccionado]="btn.iconoSeleccionado"
      [permiso]="btn.permiso"
      [estatusPermitidos]="btn.estatusPermitidos"
      [estatusActual]="estatusActual"
      [seleccionado]="btn.seleccionado"
      [accion]="btn.accion"
      [responsable]="this.detalleSiniestroCompleto?.Siniestro?.[0]?.respons_sini"
      [causa]="this.detalleSiniestroCompleto?.Siniestro?.[0]?.causa"
      [serie]="this.detalleSiniestroCompleto?.Siniestro?.[0]?.serie"
      (eventosBotonesNav)="procesarAccionesNavComplemento($event)">
    </app-botones-icon-seccion>
  }
</div>